import type { Ref } from 'vue'
import { useBarometerCar } from '@autobid/ui/composables/car/data/useBarometerCar'
import { useDetailsCar } from '@autobid/ui/composables/car/data/useDetailsCar'
import { useDetailsPreview } from '@autobid/ui/composables/car/data/useDetailsPreview'
import { useCarPageType } from '@autobid/ui/composables/car/useCarPageInfo'
import { getIdFromSlug } from '@autobid/ui/utils/car/getIdFromSlug'
import { computed } from 'vue'

export function useAuctionId(): Ref<number | undefined> {
  const pageType = useCarPageType()
  const route = useRoute()
  const slug = computed(() => String(route.params.slug))
  const carOrAuctionId = computed(() => getIdFromSlug(slug.value))
  const auctionIdInRoute = computed(() => {
    if (!route.params.auctionId)
      return null

    const numberAuctionId = Number(route.params.auctionId)
    return Number.isNaN(numberAuctionId) ? null : numberAuctionId
  })

  if (typeof auctionIdInRoute === 'number') {
    return computed(() => auctionIdInRoute)
  }

  if (pageType.value === 'details') {
    const { data: car } = useDetailsCar(carOrAuctionId)
    return computed(() => car.value?.item.itemData.auctionId)
  }

  if (pageType.value === 'barometer') {
    const { data: car } = useBarometerCar({
      type: 'item',
      carId: carOrAuctionId,
    })
    return computed(() => car.value?.item.itemData.auctionId)
  }

  if (pageType.value === 'barometerCurrent') {
    return computed(() => carOrAuctionId.value)
  }

  if (pageType.value === 'carList') {
    return computed(() => carOrAuctionId.value)
  }

  if (pageType.value === 'detailsPreview') {
    const { data } = useDetailsPreview(slug)

    return computed(() => data.value?.item.itemData.auctionId)
  }

  if (pageType.value === 'carSearch') {
    return computed(() => 0)
  }

  if (['beamerInterior', 'beamerExterior', 'beamer'].includes(pageType.value)) {
    return computed(() => Number(route.params.auctionId))
  }

  throw new Error(`Unknown page type: ${pageType.value}`)
}
